<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <div class="px-md-4 pt-md-4 d-flex flex-row justify-space-between" 
          :style="{'background-color': '#fff'}">
          <div class="subtitle-1 font-weight-black">
            Cover Image
          </div>
          <div @click="$emit('closeDialog', false)">
            <v-icon small class="cros-icon"> mdi-close </v-icon>
          </div>
        </div>
        <div class="pa-5">
          <v-tabs>
            <v-tab class="text-capitalize">Upload Files</v-tab>
            <v-tab class="text-capitalize">Media Library</v-tab>
            <v-tab-item>
              <vue-dropzone ref="myVueDropzone" id="dropzone" 
               :options="dropzoneOptions"
                @vdropzone-file-added="fileAdded"
              >  
              </vue-dropzone>
            </v-tab-item>            
            <v-tab-item>
              <v-container>
                <v-card flat>
                  <v-row>
                    <v-col
                     v-if="imgs && imgs.length" 
                     cols="12" 
                     md="4" 
                     v-for="(img, index) in imgs" :key="index"
                     :style="{'cursor': 'pointer'}"
                    >
                    <div class="image-tick-position">
                      <div v-if="img.selected" class="text-right check-icon">
                        <span class="tick-icon font-weight-white">
                          <v-icon small color="white"> mdi-check </v-icon>
                        </span>
                      </div>
                      <v-img
                       height="100"
                       width="150"
                      :class="img.selected ? 'pic-border' : '' "
                      :src="img.feature_image"
                      @click="selectedImage(index+1)"
                      >
                      </v-img>
                    </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  props: {
    dialog: {
      type: Boolean
    },
    coverImageId: {
      type: Number
    }
  },

  components: {
    vueDropzone: vue2Dropzone
  },

  created() {
    this.getListOfUploads();
  },

  data() {
    return {
      imgs: [],
      images: [],
      lastIndex: null,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFiles: 1,
        maxFilesize: 16,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        dictDefaultMessage: "<h3>Drop files to Upload</h3><div class='mt-5'><span class='dropzone-icon'><i class = 'v-icon notranslate mdi mdi-close mdi-cloud-upload'></i></span></div><div class='mt-5'><h5>Maximum upload file size 16MB</h5></div>"
      }
    }
  },


  methods: {
    async getListOfUploads() {
      await this.$http({
          method: "get",
          url: `/uploads`
      }).then(res => {
        this.images = res.data.results
      });
    },
    selectedImage(index) {
      if(this.lastIndex) {
        this.imgs[this.lastIndex - 1].selected = false;
      }
      this.imgs[index - 1].selected = true;
      this.lastIndex = index;
      this.$emit('updateItem', this.imgs[index - 1]);
      this.$emit('closeDialog', false);
    },

    fillImages() {
      this.imgs = this.images.map((img, index) => ({
        ...img, 
        selected: this.setLastIndex(img.id, index + 1)
      }));
    },

    setLastIndex(id, index) {
      if(id == this.coverImageId) {
        this.lastIndex = index
        return true
      }
      return false
    },

    async fileAdded(file) {
      var form = new FormData();
      let image = this.$refs.myVueDropzone.dropzone.files[0];
      form.append('feature_image', image, image.name);
      try{
        let item = await this.$http({
          method: "post",
          url: `/uploads/`,
          data: form
        })
        if(item.status == 201) {
          this.$emit('updateItem', item.data)
          this.$emit('closeDialog', false);
          this.$refs.myVueDropzone.removeFile(image);
          this.images.push({
            feature_image: `https://temasek-api.mgtech.cc${item.data.feature_image}`,
            id: item.data.id,
            remark: null,
            timestamp: item.data.timestamp
          })
        }
      } catch(e) {
        console.log(e)
      } 
    }
  },

  watch: {
    images: {
      handler: 'fillImages'
    }
  }
}
</script>
<style lang="scss">
.tick-icon {
  width: 20px;
  height: 20px;
  background-color: #512DA8; 
}
.pic-border {
  border: 4px solid #512DA8;
}
.image-tick-position {
  position: relative;
  .check-icon {
    position: absolute;
    position: absolute;
    z-index: 2;
    right: 7px;
    top: -7px;
  }
}
.cros-icon {
  cursor: pointer;
}
.dz-error-message {
    display: block;
    top: 200px !important;
}
.dropzone-icon {
  background-color: #eee;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid blue;
}
</style>